import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

export interface IGenerateProductNameByAi extends IAction<string, GenerateProductNameByAiArgs> {}

@InputType()
export class GenerateProductNameByAiArgs extends ActionArgs {
  @Field(() => ID)
  productId: string

  // Note: user field is inherited from ActionArgs base class
}
